import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FileDownloadDoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"file_download_done"}/>
}
